import React, { useEffect, useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import ConsumerConfirm from './consumer-confirm/ConsumerConfirm';
import SonarDashboard from './sonar-dashboard/SonarDashboard';
import { PROJECT_TYPES, PROJECT_VARIANTS } from '../constants';
import { getServerUrl } from '../redux/security/securityActions';
import Scout from './scout/Scout';
import Genie from './genie/Genie';
import Resonance from './resonance/Resonance';
import GenieGo from './genie-go/GenieGo';
import Id8 from './id8/Id8';
import Activ8 from './activ8/Activ8';
import { ProjectProvider } from '../context/ProjectContext';

import './ConsumerPage.scss';

const ConsumerPage = () => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;

  const projectType = pathname.split('/')[1];
  const isConfirmed = useSelector((state) => state.consumer.isConfirmed);

  const projectTypeUpper = useMemo(() => projectType.toUpperCase(), [projectType]);

  useEffect(() => {
    dispatch(getServerUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!isConfirmed ? <ConsumerConfirm /> : null}

      {projectTypeUpper === PROJECT_TYPES.SONAR && isConfirmed ? <SonarDashboard /> : null}
      {projectTypeUpper === PROJECT_TYPES.SCOUTV2 && isConfirmed ? <Scout /> : null}
      {projectTypeUpper === PROJECT_TYPES.GENIE && isConfirmed ? (
        <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.GENIE}>
          <Genie />
        </ProjectProvider>
      ) : null}
      {projectTypeUpper === PROJECT_TYPES.RESONANCE && isConfirmed ? <Resonance /> : null}
      {projectTypeUpper === PROJECT_TYPES.GENIE_GO && isConfirmed ? <GenieGo /> : null}
      {projectTypeUpper === PROJECT_TYPES.ACTIV8 && isConfirmed ? <Activ8 /> : null}
      {projectTypeUpper === PROJECT_TYPES.ID8 && isConfirmed ? (
        <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.ID8}>
          <Id8 />
        </ProjectProvider>
      ) : null}
    </>
  );
};

export default memo(ConsumerPage);
